export enum UserType {
    User = 0,
    SharedMailbox = 1,
    PublicMailbox = 2
}
